import { configureStore } from "@reduxjs/toolkit";
import ThemeReducer from "../Slices/Theme"
const store = configureStore({
    reducer:{
        theme:ThemeReducer,
    }
});
export default store;